import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";

import ModalWrapper from "./ModalWrapper";

export default class CurrencyDeleteModal extends React.Component {
	constructor(props) {
		super(props);

		this.handleClose = this.handleClose.bind(this);
		this.handleConfirm = this.handleConfirm.bind(this);
	}

	handleConfirm() {
		this.props.onDelete(this.props.currencyId);
		this.handleClose();
	}

	handleClose() {
		this.props.onClose();
	}

	render() {
		const footerElements = [
			<Button key={0} onClick={this.handleConfirm}>Confirm</Button>,
			<Button key={1} onClick={this.handleClose}>Close</Button>
		];

		return (
			<ModalWrapper
				title={"Currency Delete Confirmation"}
				modalClassName={"budget-audit-modal"}
				footerElements={footerElements}
			>
				<p>Are you sure you want to delete this currency?</p>
			</ModalWrapper>
		);
	}
}

CurrencyDeleteModal.propTypes = {
	onClose: PropTypes.func,
	onDelete: PropTypes.func,
	currencyId: PropTypes.number
};



// WEBPACK FOOTER //
// ./Components/components/CurrencyDeleteModal.jsx